import { render, staticRenderFns } from "./ShopThankYou.vue?vue&type=template&id=8221cad4&scoped=true&"
import script from "./ShopThankYou.vue?vue&type=script&lang=js&"
export * from "./ShopThankYou.vue?vue&type=script&lang=js&"
import style0 from "./ShopThankYou.vue?vue&type=style&index=0&id=8221cad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8221cad4",
  null
  
)

export default component.exports